import { useAuthentication } from '~/composables/useAuthentication'
import { getRedirect } from '~/src/utils/redirects'

export default defineNuxtRouteMiddleware((to) => {
  const path = to.path.replace(/\/$/, '').split('/')

  const { isAuthenticated } = useAuthentication()
  const redirect = getRedirect(path, isAuthenticated())

  if (!redirect) return

  return navigateTo(redirect)
})
